import { useContext } from 'react';
import { ThemesDispatchContext, ThemeStateContext, IThemesState, DispatchThemes } from '@insync-students-stores/themeContext';

/**
 * useThemesState Hook
 */
function useThemesState() {
  const context = useContext(ThemeStateContext);
  if (context === undefined) {
    throw new Error('useThemesState context must be used within a Provider');
  }
  return context;
}

/**
 * useThemestDispatch Hook
 */
function useThemesDispatch() {
  const context = useContext(ThemesDispatchContext);
  if (context === undefined) {
    throw new Error('useThemesDispatch must be used within a Provider');
  }
  return context;
}

/**
 * useThemes Hook
 */
function useThemes(): [Partial<IThemesState>, DispatchThemes] {
  return [useThemesState(), useThemesDispatch()];
}
export { useThemes, useThemesState, useThemesDispatch };